import React, {useEffect, useRef, useState} from 'react';
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";

import {AccessRights} from "../../schemas/accessRightsModel";
import {VISUALIZER_MANAGEMENT_ACTIONS} from "../VisualizerManagement/VisualizerManagement";
import {updateJob} from "./JobBoardActions";
import {toggle_modal} from "../../actions/A_Popups";
import {getJobEditIframeUrl} from "./getJobIframeUrl";

const JobBoardRecalculateButton = (props) => {

  const {job, auth, asCustomer, AR, language, updateJob, toggle_modal} = props;
  const [recalculatingLoading, setRecalculatingLoading] = useState(false);
  const [iframeUrl, setIframeUrl] = useState("");
  const iframeElement = useRef(null);

  const setListener = (event) => {
    if (!job.markUpLogic) {
      return false
    }
    if (recalculatingLoading && event && event.data
      && (event.data.action === VISUALIZER_MANAGEMENT_ACTIONS.visualizerIsSaved)
      && event.data.saveJobResponse && (event.data.saveJobResponse.jobId === job.id)) {
      console.log("visualizerIsSaved received", event.data);
      setRecalculatingLoading(false);
      if (event.data.saveJobResponse && event.data.saveJobResponse.hasOwnProperty('total')) {
        const markUpLogic = JSON.parse(job.markUpLogic);
        delete markUpLogic["isUpdatedInJobBoard"];
        updateJob(job, {
          markUpLogic: JSON.stringify(markUpLogic),
          total: event.data.saveJobResponse.total.materialCost,
          grandTotal: event.data.saveJobResponse.total.materialCost,
        });
      }
    }
  }

  function onBeforeUnload(e) {
    if (!job.markUpLogic) {
      return false
    }
    if (recalculatingLoading && job.markUpLogic.includes('isUpdatedInJobBoard')) {
      e = e || window.event;
      // For IE and Firefox prior to version 4
      if (e) {
        e.returnValue = 'Sure?';
      }
      // For Safari
      return 'Sure?';
    }
    delete e['returnValue'];
    return false
  }

  useEffect(() => {
    window.addEventListener("message", setListener);
    window.addEventListener('beforeunload', onBeforeUnload);
    return () => {
      window.removeEventListener("message", setListener);
      window.addEventListener('beforeunload', onBeforeUnload);
    }
  })

  if (!job.markUpLogic || !job.markUpLogic.includes('isUpdatedInJobBoard')) {
    return null
  }

  const recalculateJobClick = async () => {
    console.log("job", job);
    setRecalculatingLoading(true);
    if (!iframeUrl) {
      const currentIframeUrl = await getJobEditIframeUrl(job, asCustomer, auth, AR, language)
      setIframeUrl(currentIframeUrl + "&saveOnLoad=true")
    }
    toggle_modal(true, "Keep this browser window open while recalculation is taking place", [{
      text: "Close",
      color: "green",
      onClick: () => toggle_modal(false)
    }]);
  }

  if (recalculatingLoading) {
    return (
      <div className="flex flex--center" style={{marginTop: "1px"}}>
        <div className="ui-loader ui-loader--small"/>
        {iframeUrl ? <iframe style={{opacity: 0, visibility: "hidden", width: "1px", height: "1px", position: "absolute"}}
                             src={iframeUrl}
                             ref={iframeElement} /> : null}
      </div>
    )
  }

  return (
    <button className="ui-button3 ui-button3--green text-uppercase bold"
            style={{marginTop: "4px", color: "black"}}
            onClick={recalculateJobClick}>
      <FormattedMessage id="messageBox.buttons.recalculate"/>
    </button>
  )
};

const mapStateToProps = (state) => {
  const {auth, asCustomer, dashboardState} = state;
  return {
    auth,
    asCustomer,
    AR: AccessRights.get(state),
    language: dashboardState.language,
  };
};

const mapDispatchToProps = {
  updateJob,
  toggle_modal,
};

export default connect(mapStateToProps, mapDispatchToProps)(JobBoardRecalculateButton)
